import { render, staticRenderFns } from "./BimDemolition.vue.html?vue&type=template&id=567c077e&lang=html&external"
import script from "./BimDemolition.vue.js?vue&type=script&lang=js&external"
export * from "./BimDemolition.vue.js?vue&type=script&lang=js&external"
import style0 from "./BimDemolition.vue.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports